export { BrandsListPage as default } from './BrandsListPage';
